import { faFileSlash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { useMemo } from 'react'
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer'
import { useConfig } from '~/domains/configuration/queries/config'
import { themeClass } from '~/styles/theme.css'
import type { AttachmentType } from '../../types'
import {
  attachmentsGeneratingSubtitle,
  attachmentsGeneratingTitle,
  noAttachments,
  noAttachmentsIcon
} from '../AttachmentsViewer.css'

export const DocumentViewer = ({
  attachment
}: {
  attachment: AttachmentType
}) => {
  const { data: legacyUrl } = useConfig('organization.legacy_url')
  const documentUrl = useMemo(() => {
    if (!attachment.url) return null

    return attachment.url.indexOf('/admin') !== -1
      ? `${legacyUrl}${attachment.url}`
      : attachment.url
  }, [attachment.url, legacyUrl])

  const documents = useMemo(() => {
    if (!documentUrl) return []

    return [
      {
        uri: documentUrl,
        fileName: attachment.name,
        fileType: attachment.mimeType ?? attachment.formatInfo?.extension
      }
    ]
  }, [
    documentUrl,
    attachment.name,
    attachment.mimeType,
    attachment.formatInfo?.extension
  ])

  if (documents.length === 0) {
    return (
      <div className={clsx(noAttachments, themeClass)}>
        <div className={noAttachmentsIcon}>
          <FontAwesomeIcon icon={faFileSlash} />
        </div>
        <div className={attachmentsGeneratingTitle}>
          Erreur lors du chargement du document
        </div>
        <div className={attachmentsGeneratingSubtitle}>
          Le contenu du document n'est pas disponible.
        </div>
      </div>
    )
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <DocViewer
        documents={documents}
        pluginRenderers={DocViewerRenderers}
        config={{
          header: {
            disableHeader: true,
            disableFileName: true
          }
        }}
        style={{ height: '100%' }}
      />
    </div>
  )
}
